// @import
import { ensureHTMLNodeList } from "@src/js/lib/ensure";
import Alpine from "alpinejs";

Alpine.directive("tabs", (element, {}, { cleanup }) => {
  const dom = {
    triggers: ensureHTMLNodeList(element.querySelectorAll(".c-tabs__trigger")),
    tabs: ensureHTMLNodeList(element.querySelectorAll(".c-tabs__tab")),
    mobileDropdownButtonLabel: element.querySelector(
      ".c-tabs__triggers-mobile-dropdown .c-dropdown__trigger .c-button__label",
    ),
  };

  if (!dom.triggers.length || !dom.tabs.length) {
    return;
  }

  function toggleTab(tabId: string) {
    dom.tabs.forEach((tab) => {
      if (tab.getAttribute("id") === tabId) {
        tab.classList.add("c-tabs__tab--active");
      } else {
        tab.classList.remove("c-tabs__tab--active");
      }
    });
  }

  function handleTabTriggerClick(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;
    const targetTabId = target.getAttribute("data-tab");
    const label = target.textContent?.trim() || "";

    if (dom.mobileDropdownButtonLabel) {
      dom.mobileDropdownButtonLabel.textContent = label;
    }

    if (targetTabId) {
      toggleTab(targetTabId);

      dom.triggers.forEach((trigger) => {
        trigger.classList.remove("c-tabs__trigger--active");
      });
      target.classList.add("c-tabs__trigger--active");
      window.dispatchEvent(new CustomEvent("tabChange", { detail: { tabId: targetTabId } }));
    }
  }

  dom.triggers.forEach((trigger) => {
    trigger.addEventListener("click", handleTabTriggerClick);
  });

  cleanup(() => {
    dom.triggers.forEach((trigger) => {
      trigger.removeEventListener("click", handleTabTriggerClick);
    });
  });
});
